import React from 'react'
// import { selectAllUsers } from '../users/usersApiSlice'
// import { useSelector } from 'react-redux'
import NewNoteForm from './NewNoteForm'
import { useGetUsersQuery } from '../users/usersApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'

const NewNote = () => {
    const {users} = useGetUsersQuery("usersList", {
      selectFromResult: ({data})=>({
        users: data?.ids.map(id => data?.entities[id])
      }),
    })
    // const users = useSelector(selectAllUsers)

    if(!users?.length) return <PulseLoader color={"#FFF"}/>
    // if(!users?.length) return <p>Not Currently available</p>

    const content = <NewNoteForm users={users}/>
    // const content = users? <NewNoteForm users={users}/> : <p>Loading...</p>
  return content
}

export default NewNote